"use strict";

window.App = window.App || {};
window.App.companyOwner = {
	init: function () {
		const $selects = $('[data-company-owner-select]');
		if (!$selects.length) return;

		const formatUser = function (option) {
			if (!option.id) return option.text;

			const element = option.element;
			const name = option.text || '';
			const title = element?.dataset?.title || '';
			const avatar = element?.dataset?.avatar || '';
			const avatarColor = (window.App.userSelect && window.App.userSelect.safeAvatarColor)
				? window.App.userSelect.safeAvatarColor(element?.dataset?.avatarColor || '')
				: (element?.dataset?.avatarColor || '#0E5DCB');
			const parts = name.trim().split(/\s+/);
			const initials = parts.length > 1
				? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
				: name.slice(0, 2).toUpperCase();
			const hasAvatar = avatar && !avatar.includes('blank.png');
			const safeName = $('<div>').text(name).html();
			const safeTitle = $('<div>').text(title).html();

			return $(
				'<div class="contact-owner-select2-option">' +
					'<span class="contact-owner-select2-avatar-wrap" style="background-color: ' + avatarColor + ';">' +
						(hasAvatar ? '<img src="' + avatar + '" class="contact-owner-select2-avatar" alt="" style="width:32px;height:32px;max-width:32px;object-fit:cover;border-radius:50%;">' : '') +
						'<span class="contact-owner-select2-initials"' + (hasAvatar ? ' style="display:none;"' : '') + '>' + initials + '</span>' +
					'</span>' +
					'<span class="contact-owner-select2-details">' +
						'<span class="contact-owner-select2-name">' + safeName + '</span>' +
						(title ? '<span class="contact-owner-select2-title">' + safeTitle + '</span>' : '') +
					'</span>' +
				'</div>'
			);
		};

		$selects.each(function () {
			const $select = $(this);

			if ($select.hasClass('select2-hidden-accessible')) {
				$select.select2('destroy');
			}

			$select.select2({
				allowClear: true,
				dropdownParent: $('#company_profile_contents'),
				minimumInputLength: 0,
				placeholder: $select.data('placeholder'),
				templateResult: formatUser,
				templateSelection: formatUser,
				width: '100%'
			});

			let lastGoodValue = $select.val() || null;
			let suppressChange = false;

			$select.off('.companyOwner').on('change.companyOwner', function () {
				if (suppressChange) {
					return;
				}

				const nextValue = $select.val() || null;
				window.App.companyOwner.assign(
					Number($select.data('company-id')),
					nextValue
				).done(function () {
					lastGoodValue = nextValue;
					window.App.companyOwner.sync($select, nextValue);
				}).fail(function () {
					suppressChange = true;
					$select.val(lastGoodValue).trigger('change.select2');
					suppressChange = false;
				});
			});
		});
	},

	sync: function ($source, userId) {
		$('[data-company-owner-select]').not($source).each(function () {
			const $select = $(this);
			if (String($select.val() || '') === String(userId || '')) {
				return;
			}

			$select.val(userId || '').trigger('change.select2');
		});
	},

	assign: function (companyId, userId) {
		return $.ajax({
			type: 'POST',
			url: '/companies/update-assigned-to/id/' + companyId,
			data: {
				_token: $('meta[name="csrf-token"]').attr('content'),
				user_id: userId
			}
		}).done(function (response) {
			window.toastSuccess?.(response.message || 'Company owner updated successfully.');
			window.companiesDataTable?.ajax?.reload(null, false);
		}).fail(function (xhr) {
			window.toastError?.(xhr.responseJSON?.message || 'Unable to update company owner.');
		});
	},

	claim: function (companyId) {
		return $.ajax({
			type: 'POST',
			url: '/companies/claim/id/' + companyId,
			data: {
				_token: $('meta[name="csrf-token"]').attr('content')
			}
		}).done(function (response) {
			window.toastSuccess?.(response.message || 'Company ownership request submitted.');
			window.viewCompany(new Event('click'), companyId);
			window.companiesDataTable?.ajax?.reload(null, false);
		}).fail(function (xhr) {
			window.toastError?.(xhr.responseJSON?.message || 'Unable to claim company.');
		});
	}
};

window.App.companyProfile = {
	preferenceTimer: null,

	escapeHtml: function (value) {
		return $('<div>').text(value == null ? '' : String(value)).html();
	},

	metricOptionFormat: function (item) {
		if (!item.id || !item.element) {
			return item.text;
		}

		const label = item.element.getAttribute('data-kt-rich-content-subcontent') || '';
		const span = document.createElement('span');
		span.innerHTML = '<div class="d-flex flex-column">'
			+ '<span class="fs-6 fw-bolder">' + window.App.companyProfile.escapeHtml(item.text) + '</span>'
			+ '<span class="fs-8 company-metric-option__label">' + window.App.companyProfile.escapeHtml(label) + '</span>'
			+ '</div>';

		return $(span);
	},

	renderTypeChips: function (types) {
		const $host = $('#company_profile_types');
		if (!$host.length) {
			return;
		}

		const limit = Number($host.data('chip-limit')) || 2;
		const selected = (types || []).filter(function (type) {
			return type && type.id;
		});

		if (!selected.length) {
			$host.html('<span class="company-profile-empty">---</span>');
			return;
		}

		const chips = selected.map(function (type, index) {
			const extra = index >= limit ? ' company-profile-chip--extra d-none' : '';
			const id = window.App.companyProfile.escapeHtml(type.id);
			const name = window.App.companyProfile.escapeHtml(type.text || '');

			return '<span class="company-profile-chip' + extra + '" data-type-id="' + id + '">'
				+ name
				+ ' <button type="button" class="company-profile-chip__remove" aria-label="Remove ' + name + '">&times;</button>'
				+ '</span>';
		}).join('');

		const extraCount = Math.max(0, selected.length - limit);
		const more = extraCount
			? '<button type="button" class="company-profile-chip-more" data-company-chip-more>+' + extraCount + '</button>'
			: '';

		$host.html(chips + more);
	},

	collectMetrics: function () {
		const metrics = {};

		$('[data-company-metric-slot]').each(function () {
			const slot = $(this).attr('data-company-metric-slot');
			const metric = $(this).find('option:selected').attr('data-kt-rich-content-subcontent') || $(this).val();

			if (slot && metric) {
				metrics[slot] = metric;
			}
		});

		return metrics;
	},

	persistMetrics: function () {
		clearTimeout(window.App.companyProfile.preferenceTimer);

		window.App.companyProfile.preferenceTimer = setTimeout(function () {
			const token = $('meta[name="csrf-token"]').attr('content');
			const metrics = window.App.companyProfile.collectMetrics();

			if (!token || Object.keys(metrics).length === 0) {
				return;
			}

			$.ajax({
				url: '/companies/display-preferences',
				type: 'POST',
				data: {
					_token: token,
					metrics: metrics
				}
			});
		}, 400);
	},

	init: function () {
		const $slots = $('[data-company-metric-slot]');
		if (!$slots.length || !$.fn.select2) {
			return;
		}

		$slots.each(function () {
			const $select = $(this);

			if ($select.hasClass('select2-hidden-accessible')) {
				$select.select2('destroy');
			}

			$select.select2({
				templateSelection: window.App.companyProfile.metricOptionFormat,
				templateResult: window.App.companyProfile.metricOptionFormat,
				minimumResultsForSearch: Infinity,
				width: '100%',
				dropdownCssClass: 'company-metric-select-dropdown',
				dropdownParent: $('#company_profile_contents')
			});

			$select.off('select2:select.companyProfile').on('select2:select.companyProfile', function () {
				window.App.companyProfile.persistMetrics();
			});
		});

		const tooltipTriggerList = document.querySelectorAll('#company_profile_contents [data-bs-toggle="tooltip"]');
		tooltipTriggerList.forEach(function (el) {
			if (window.bootstrap?.Tooltip && !bootstrap.Tooltip.getInstance(el)) {
				new bootstrap.Tooltip(el);
			}
		});
	}
};

$(document).on('click', '#company_profile_types .company-profile-chip__remove', function (event) {
	event.preventDefault();
	const id = String($(this).closest('.company-profile-chip').data('type-id'));
	const $select = $('#company_type_ids');
	if (!$select.length) {
		return;
	}

	const next = ($select.val() || []).filter(function (value) {
		return String(value) !== id;
	});
	$select.val(next).trigger('change');
});

$(document).on('click', '[data-company-chip-more]', function (event) {
	event.preventDefault();
	const $host = $(this).closest('.company-profile-chips');
	$host.find('.company-profile-chip--extra').removeClass('d-none');
	$(this).remove();
});
